module.exports = __webpack_public_path__ + "lato-light-webfont.b0979ecf8b53bc888aa9.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-light-webfont.svg
// module id = ../../../../../resources/fonts/lato-light-webfont.svg
// module chunks = styles